import React from 'react';
import { OptionIconProps } from '../../Popup/PopupOption';

export const SignOutIcon: React.FC<OptionIconProps> = ({
  disabled = false,
}): JSX.Element => {
  const color = disabled ? '#cccccc' : '#c32c2c';
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.24333 1.66663H2V12.7866H5.24333M10.34 3.98329L13.5833 7.22663L10.34 10.47M5.70667 7.22663H13.5833"
        stroke={color}
        strokeWidth="2.085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
